export function plainMapLayers(layerGroup, result = []) {
    layerGroup.getLayers().forEach(layer => {
        if (layer.getLayers) {
            plainMapLayers(layer, result)
        } else {
            result.push(layer)
        }
    })

    return result
}

export function isCadastralLayerMeta(value = '') {
    const normalized = String(value).toLowerCase()
    return normalized.includes('geo_lote') || normalized.includes('geo_edificacao')
}

export function isCadastralMapLayer(layer) {
    if (layer.get('is_label_layer')) {
        return false
    }

    if (layer.get('isMain')) {
        return true
    }

    const name = String(layer.get('name') || '').trim().toLowerCase()
    if (name === 'lotes' || name === 'edificações' || name === 'edificacoes') {
        return true
    }

    const meta = [
        layer.get('geo_table'),
        layer.get('geo_server_layer'),
        layer.get('font'),
    ].filter(Boolean).join(' ')

    return isCadastralLayerMeta(meta)
}

export function mapLayerToBulkOption(layer) {
    const idForApi = layer.get('isMultifinalitario')
        ? `m-${layer.get('layer_id')}`
        : String(layer.get('id') ?? '')

    return {
        value: idForApi,
        label: layer.get('name'),
        geoDocumentLayerType: layer.get('isMultifinalitario') ? 'multifinalitario' : 'geoserver',
        isCadastral: isCadastralMapLayer(layer),
    }
}
